import React from "react";

const ComingSoon = () => {
  return (
    <div
      className="min-h-screen flex items-center justify-center text-white transition-colors duration-500"
      // style={{ backgroundColor: "#f3f4f6" }}
    >
      <div className="text-center p-8 max-w-lg">
        <h1 className="text-5xl font-bold mb-4 text-gray-900">Coming Soon</h1>
        <p className="text-gray-600 text-lg mb-6">
          We are working hard to bring something amazing. Stay tuned!
        </p>
      </div>
    </div>
  );
};
export default ComingSoon;
